import { createContext } from 'react'

const ContrastModeContext = createContext(false)

export default ContrastModeContext
